import { Component } from "solid-js"
import { createMutable } from "solid-js/store"
import createEngineForUI from "../../lib/core/engine/createEngineForUI"
import { Engine } from "../../lib/core/engine/Engine.type"
import createSampleEntity from "../../lib/core/entity/createSampleEntity"
import { EntityTypeId } from "../../lib/core/entity/EntityTypeId.enum"
import { createFirstPlayerIdMemo } from "../../rx/memo/createFirstPlayerIdMemo"
import EngineContext from "../EngineContext"
import SingleEntityIcon3D from "./SingleEntityIcon3D"

const NewGameIcon: Component = () => {
  const engine: Engine = createMutable(createEngineForUI())
  // need sample player for UI engine
  const samplePlayerId = createFirstPlayerIdMemo(engine)

  // bindEngineToComponent(engine)

  return <EngineContext.Provider value={engine}>
    <SingleEntityIcon3D
      entity={createSampleEntity(EntityTypeId.LightTank, samplePlayerId())}
      size={32}
      // style={({ "margin-top": `-48px`, "margin-bottom": `-8px` })}
      style={({ "margin-top": `-16px`, "margin-bottom": `-8px` })}
    />
  </EngineContext.Provider>
}

export default NewGameIcon
